import {Component, Input} from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { WalkthroughStep } from 'src/app/services/onboarding.service';

@Component({
  selector: 'app-onboarding-popover',
  templateUrl: './onboarding-popover.component.html',
  styleUrls: ['./onboarding-popover.component.scss']
})
export class OnboardingPopoverComponent {
  @Input() step: WalkthroughStep & { resources?: { label: string, url: string }[] };
  @Input() isLast: boolean = false;
  @Input() rect: DOMRect;

  constructor(private popoverController: PopoverController, private router: Router) {
    console.log("OnboardingPopoverComponent:ctor", this.step);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

  nextStep() {
    if (this.step && (this.step as any).routeAction) {
      const route = (this.step as any).routeAction as string;
      if (route) {
        this.router.navigateByUrl(route);
      }
    }
    this.popoverController.dismiss();
  }

}